import React from "react";
import { useQuery } from "@apollo/client";
import styled from "styled-components";
import AddFavoriteButton from "./AddFavoriteButton";
import RemoveFavoriteButton from "./RemoveFavoriteButton";
import { TransitionGroup } from "react-transition-group";
import { ME_USER_QUERY } from "@/graphql/queries/users";

export const StyledAnimatedButton = styled.div`
  display: inline-block;
  transition: 300ms;
  position: ${(props) => (props.$inFlow ? "relative" : "absolute")};
  &.enter {
    transform: rotate3d(0, 0, 0, 0deg);
  }

  &.enter-active {
    transform: rotate3d(1, 0, 0, 180deg);
  }

  &.enter-done {
    transform: rotate3d(1, 0, 0, 0deg);
  }

  &.exit {
    transform: rotate3d(1, 0, 0, 180deg);
  }
`;

const favoriteButtonWrapper = (props) => {
  const { data, error } = useQuery(ME_USER_QUERY);
  if (error)
    return (
      <AddFavoriteButton
        show={true}
        compact={props.compact}
        inFlow={props.inFlow}
      />
    );
  const touched = (data?.me?.favorites || []).some(
    (favorite) => favorite.job?.id === props.jobId
  );
  const inFlow = !!(props.compact || props.inFlow);
  return (
    <div
      className={
        inFlow ? "FavoriteButtonWrapper inFlow" : "FavoriteButtonWrapper"
      }
    >
      <TransitionGroup>
        <RemoveFavoriteButton
          jobId={props.jobId}
          show={touched}
          count={props.count}
          compact={props.compact}
          inFlow={inFlow}
        />
        <AddFavoriteButton
          jobId={props.jobId}
          show={!touched}
          count={props.count}
          compact={props.compact}
          inFlow={inFlow}
        />
      </TransitionGroup>
      <style jsx>{`
        .FavoriteButtonWrapper {
          display: flex;
          align-items: center;
          min-width: 116px;
          min-height: 34px;
        }

        .FavoriteButtonWrapper.inFlow {
          min-width: auto;
          min-height: 32px;
          position: relative;
          flex-shrink: 0;
        }
      `}</style>
    </div>
  );
};

export default favoriteButtonWrapper;
